// extracted by css-extract-rspack-plugin
export default {"marginRight":"_2448259c","tabletStyles":"_79036b0c"};